import { ACR_VALUES } from '@zillow/auth-core';

export type ZillowLoginBaseOptions = {
  /** App name (for analytics) */
  entryPoint: string;

  /**
   * Optional: disable force login to allow a user with an existing session to complete login flow
   * without any interaction. The default behavior to force the user to login with credentials which
   * extends their session.
   *
   * @default false
   * */
  disableForceLogin?: boolean;
};

/**
 * Default options for rental manager login, including custom UI configuration.
 */
export const rentalManagerLoginOptions = { uiConfig: { brand: 'zillow-rentals' } } as const;

/**
 * Options for with AAL2 step-up assurance level, also disables force login to re-use existing sessions
 */
export const rentalManagerStepUpLoginOptions = {
  oauthOptions: { acr_values: ACR_VALUES.AAL2 },
  disableForceLogin: true,
} as const;

/**
 * Builds rentalManagerLoginOptions with acr_values derived from the auth user
 * DTO. When the user needs initial multi-factor authentication, request AAL2
 * on the redirect so the login flow triggers the MFA step-up.
 */
export function rentalManagerLoginOptionsForUser(
  user?: { isInitialMultiFactorAuthenticationRequired?: boolean } | null,
) {
  return {
    ...rentalManagerLoginOptions,
    ...(user?.isInitialMultiFactorAuthenticationRequired ? rentalManagerStepUpLoginOptions : {}),
  };
}
